import {post} from "../../functions";
import {standardResponse} from "../../messages";

export async function initSettings() {
    const passwordForm = document.querySelector('form.password');
    const passwordFormInput = document.querySelector('form.password input');

    passwordForm.addEventListener('submit', async () => {
            if (passwordForm.validateForm()) {
                const resp = await post('api/settings/password', passwordForm);
                console.log(resp);
                if (resp.status === '200') {
                    passwordFormInput.value = '';
                }
                standardResponse(resp.status, resp.payload.message || '');
            } else {
                standardResponse('000');
            }
        }
    )
}